import { useEffect, useState } from 'preact/hooks'
import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './save-toast.module.css'

/** How long the toast stays, in ms. */
const SHOWN_MS = 2500

/**
 * "Game saved" (or "Couldn't save the game") at the top centre for 2.5 s after each save
 * attempt (`view.saves.lastSaved`). Over the HUD and the eyelids: a night's save happens in
 * the dark, and the toast shows through the wake-up.
 */
export function SaveToast() {
  const t = useT()
  const last = useView((view) => view.saves.lastSaved)
  // The attempt whose toast is over (or that came before this page showed the HUD).
  const [done, setDone] = useState(last?.at ?? null)
  useEffect(() => {
    if (last === null || last.at === done) return
    const timer = setTimeout(() => {
      setDone(last.at)
    }, SHOWN_MS)
    return () => {
      clearTimeout(timer)
    }
  }, [last, done])

  if (last === null || last.at === done) return null
  return (
    <p key={last.at} class={styles.toast} role="status" data-failed={!last.ok || undefined}>
      {t(text(last.ok ? 'toast.saved' : 'toast.saveFailed'))}
    </p>
  )
}
